import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	IconButton,
	Tooltip,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles({
	root: {
		width: '100%',
	},
	container: {
		maxHeight: 440,
	},
});

export default function PaginateTable({
	columns,
	data,
	rowsPerPage,
	handleChangePage,
	handleChangeRowsPerPage,
	page,
	action,
}) {
	const classes = useStyles();

	return (
		<Paper>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label='sticky table'>
					<TableHead>
						<TableRow>
							{columns.map(column => (
								<TableCell
									key={column.id}
									align={column.align}
									style={{ minWidth: column.minWidth, fontWeight: column.fontWeight }}
								>
									{column.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{data?.rows.map(row => {
							return (
								<TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
									<TableCell>
										<span>{row.firstName || row.applicant?.firstName}</span>
									</TableCell>
									<TableCell>
										<span>{row.lastName || row.applicant?.lastName}</span>
									</TableCell>
									<TableCell>
										<span>{row.nationalId || row.applicant?.nationalId}</span>
									</TableCell>
									<TableCell>
										<span>{row.phone || row.applicant?.phone}</span>
									</TableCell>
									<TableCell>
										<span>{row.email || row?.referenceId}</span>
									</TableCell>
									<TableCell>
										<span>{action(row.id)}</span>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[10, 25, 100]}
				component='div'
				count={data?.count || 0}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</Paper>
	);
}
